export default function MissionSection() {
  return (
    <section className="section-space bg-[#F8F6F3]">
      <div className="shell purpose-grid">
        <div>
          <p className="eyebrow">Our purpose</p>
          <h2>
            Shared prosperity.
            <br />
            Built from the ground up.
          </h2>
        </div>
        <div>
          <p className="large-copy">
            Africa’s future is shaped by the people who build, learn, and invest
            in it. Harambee brings those ambitions together.
          </p>
          <p className="body-copy">
            Our mission is to connect African and diaspora talent, knowledge,
            and resources in support of enterprise, economic participation, and
            intergenerational wealth. We begin with education and relationships,
            guided by local priorities and long-term thinking.
          </p>
          <div className="principle-tags">
            <span>Local ownership</span>
            <span>Education first</span>
            <span>Shared opportunity</span>
          </div>
        </div>
      </div>
    </section>
  );
}
